export default __webpack_public_path__ + "static/media/vu.f04f6853.svg";